<template>
  <div>
    <footer class="site-footer text-center">
      <div class="site-footer__links" v-if="$store.state.app !== 'consignment-portal'">
        <router-link to="/terms-of-service">Terms of Service</router-link>
        <router-link to="/privacy-policy">Privacy Policy</router-link>
      </div>
    </footer>
  </div>
</template>

<script>

export default {
  components: {}
}
</script>

<style lang="scss">
@import '../styles/variables';
@import '../styles/mixins';
@import '~foundation-sites/scss/util/_util';

.site-footer {
  padding-bottom: 60px;

  &__links {
    a {
      font-size: 13px;
      margin: 0 5px;
    }
  }
}

@include breakpoint(large) {
  .section-page {
    .site-footer {
      padding-left: 200px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/globals/footer.vue